<template>
  <div class="bx-epg-select">
    <div v-if="title"
         class="bx-epg-select__header">
      <strong>{{ title }}</strong>
    </div>
    <div class="bx-epg-select__list">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
